import { StyleProp, TextStyle, ViewStyle } from 'react-native';
import { ImageStyle } from 'react-native-fast-image';
import { useResponsiveContext } from '../../functions/responsive/ResponsiveContext';
import { FontFamily } from '../styles/Colors';

export type SnackbarStyles = {
  bar?: StyleProp<ViewStyle>;
  contentContainer?: StyleProp<ViewStyle>;
  imageContainer?: StyleProp<ViewStyle>;
  image?: StyleProp<ImageStyle>;
  text?: StyleProp<TextStyle>;
  closeButton?: { size?: number; color?: string; style?: StyleProp<ViewStyle> };
};

type Preset = 'default' | 'orderReviewRemind' | 'userBadgeEarned';

export const useSnackbarStylePresets = (): {
  [p in Preset]: SnackbarStyles;
} => {
  const { rpx } = useResponsiveContext();
  return {
    // default snackbar styles
    default: {
      contentContainer: {
        paddingLeft: rpx(15),
        paddingRight: rpx(15),
        paddingTop: rpx(4),
        paddingBottom: rpx(4),
      },
      imageContainer: {
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: rpx(15),
      },
      image: {
        width: rpx(34),
        height: rpx(34),
        borderRadius: rpx(4),
      },
      closeButton: {
        size: rpx(12),
        color: '#777',
        style: {
          width: rpx(20),
          height: rpx(20),
          borderRadius: rpx(20),
          marginLeft: rpx(15),
          backgroundColor: '#CCC',
          justifyContent: 'center',
          alignItems: 'center',
        },
      },
    },

    // styles for order review reminder notification
    orderReviewRemind: {
      bar: {
        borderRadius: rpx(8),
      },
      contentContainer: {
        paddingTop: rpx(10),
        paddingBottom: rpx(10),
        borderRadius: rpx(8),
      },
      image: {
        width: rpx(50),
        height: rpx(50),
      },
      text: FontFamily.normal({
        fontSize: rpx(12),
        lineHeight: rpx(18),
      }),
      closeButton: {
        size: rpx(24),
      },
    },

    userBadgeEarned: {
      imageContainer: {
        width: rpx(50),
        height: rpx(50),
      },
      image: {
        width: rpx(44),
        height: rpx(44),
      },
      text: FontFamily.normal({
        fontSize: rpx(12),
        lineHeight: rpx(18),
        letterSpacing: rpx(-0.24),
      }),
    },
  };
};
